'use client';

import { useEffect, useState } from 'react';

import { MaterialDesignIcon } from '@hrworks/sui-core/MaterialDesignIcon';

import { S } from './BackToTop.styles';

const SCROLL_THRESHOLD = 300;

const useShowBackToTop = (threshold = SCROLL_THRESHOLD) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShow(window.scrollY > threshold);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return show;
};

export const BackToTop = () => {
  const show = useShowBackToTop();
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    if (show) setHasScrolled(true);
  }, [show]);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Don't render anything until user has scrolled past threshold at least once
  if (!hasScrolled) return null;

  return (
    <S.Wrapper $visible={show}>
      <S.IconButton onClick={handleClick} aria-label="Zurück nach oben" type="button">
        <MaterialDesignIcon name="keyboard_arrow_up" />
      </S.IconButton>
    </S.Wrapper>
  );
};
